// store/features/sagas/createCompetitorSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import { CREATE_COMPETITOR_REQUEST } from "../actions/createCompetitorActions";
import {
  createCompetitorSuccess,
  createCompetitorFailure,
} from "../actions/createCompetitorActions";
import { submitCompetitorListRequest } from "../actions/competitorListActions";
import { createCompetitor } from "../../../services/accIqService";

// function* handleCreateCompetitor(action) {
//   try {
//     const { client, competitor } = action.payload;

//     yield call(createCompetitor, client, competitor);

//     yield put(createCompetitorSuccess());
//     yield put(submitCompetitorListRequest(client));
//   } catch (error) {
//     yield put(createCompetitorFailure(error.message));
//   }
// }

function* handleCreateCompetitor(action) {
  try {
    const { client, competitor, competitorId } = action.payload;

    // Capture the response
    const response = yield call(
      createCompetitor,
      client,
      competitor,
      competitorId
    );

    // Dispatch success with response status if needed
    yield put(createCompetitorSuccess(response?.data));
    // Conditionally dispatch submitCompetitorListRequest
    if (response?.data?.status === "submitted") {
      yield put(submitCompetitorListRequest(client));
      // yield put(
      //   submitCompetitorListRequest({
      //     client: client,
      //     user_id: user?.user_id,
      //     user_type:
      //       user?.demo === APP_CONFIG?.market_iq_demo ? "MarketIQ" : "CompIQ",
      //     user_role: user?.growth_iq_role_name,
      //   })
      // );
    }
  } catch (error) {
    yield put(createCompetitorFailure(error.message));
  }
}

export default function* createCompetitorSaga() {
  yield takeLatest(CREATE_COMPETITOR_REQUEST, handleCreateCompetitor);
}
